module.exports = __webpack_public_path__ + "static/media/favepay-complete-setup.cafe9cf2.svg";